/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_BtnInputs */

const vi_confirm_return_btn = /** @type {(inputs: Confirm_Return_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận hoàn đơn`)
};

/**

* @param {Confirm_Return_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_btn = /** @type {((inputs?: Confirm_Return_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_btn(inputs)
});